import { render, staticRenderFns } from "./filter_label.vue?vue&type=template&id=5f9c861a&scoped=true&"
import script from "./filter_label.vue?vue&type=script&lang=js&"
export * from "./filter_label.vue?vue&type=script&lang=js&"
import style0 from "./filter_label.vue?vue&type=style&index=0&id=5f9c861a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9c861a",
  null
  
)

export default component.exports